import React from 'react';

interface BusCardProps {
  busId?: string;
  busName?: string;
  filledPercentage?: string;
  capacity?: number;
  allocatedPax?: number;
  totalCount?: string;
  balloon?: string;
  initials?: string;
  bgColor?: string;
}

const BusCard: React.FC<BusCardProps> = ({
  filledPercentage,
  capacity,
  allocatedPax,
  busName,
  bgColor,
  initials,
  balloon,
}) => {
  const newAllocatedPax = allocatedPax ? allocatedPax : 0;
  const newCapacity = capacity ? capacity : 0;
  const dynamicFilledPercentage = (
    (newAllocatedPax / newCapacity) *
    100
  ).toFixed(0);

  return (
    <div className={`rounded-lg p-4  ${bgColor}`}>
      <div className="flex justify-between">
        <h3 className="text-text-primary mb-1 text-[14px] font-sora text-left">
          {busName ? busName : 'B-XQ13ITS'}
        </h3>
        <p className="font-bold text-text-primary">{balloon}</p>
      </div>
      <div className="flex items-center space-x-2">
        <div className="w-full bg-[#C2F3D6] rounded-full h-2 relative">
          <div
            className={`${Number(dynamicFilledPercentage) < 101 ? 'bg-[#22AD5C]' : 'bg-red-500'}  h-2 rounded-full`}
            style={{
              width: `${Number(dynamicFilledPercentage) < 101 ? dynamicFilledPercentage : 100}%`,
            }}
          ></div>
        </div>
      </div>
      <p className="text-textColorGray text-sm mb-2 text-left">
        {dynamicFilledPercentage ? dynamicFilledPercentage : 0}% Filled
      </p>
      <div className="flex justify-between">
        <p className="font-bold">
          <span
            className={
              allocatedPax === undefined || isNaN(Number(allocatedPax))
                ? 'text-text-primary'
                : Number(allocatedPax) <= Number(capacity)
                  ? 'text-text-textGreen'
                  : 'text-text-textRed'
            }
          >
            {allocatedPax}
          </span>
          <span className="font-normal text-sm text-text-primary">
            /{capacity}
          </span>
        </p>
        <p className="text-text-purple font-bold">{initials}</p>
      </div>
    </div>
  );
};

export default BusCard;
